<template>
    <div class="metric-slider d-flex align-items-center" :class="{ disabled: props.disabled }">
        <p class="geist-font mr-4 knights-cloak--text">{{ props.label }}</p>
        <div class="slide-container">
            <div class="range" :style="rangeStyle">
                <div class="bullet"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    steps: {
        type: Number,
        default: 4,
    },
    value: {
        type: Number,
        default: 50,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const rangeStyle = computed(() => {
    const normalizedValue = Math.min(Math.max(props.value, 0), 100)
    const stepWidth = 100 / props.steps

    const position = (normalizedValue * (100 - stepWidth)) / 100

    return {
        width: `${stepWidth}%`,
        left: `${position}%`,
    }
})
</script>

<style scoped lang="scss">
@forward '@/styles/new_styles.scss';

.metric-slider {
    p {
        text-wrap: nowrap;
    }

    .slide-container {
        width: 100%;
        min-width: 150px;
        height: 10px;
        border-radius: 8px;
        background: vars.$grey05;

        position: relative;

        .range {
            height: 100%;
            border-radius: 8px;
            background: vars.$castleMoat;
            position: absolute;
            top: 0;
        }

        .bullet {
            width: 8px;
            height: 8px;
            background: black;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
